import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import StepsIcon from "../../../../assets/Fibo/icons/StepsIcon";
import { useAppStore } from "../../../../hooks/useStores";
import TextToImageStepsSlider from "../../../Playground/TextToImage/Config/Advanced/Steps/Slider/TextToImageStepsSlider";
import FiboPopoverButton from "../Popover/FiboPopoverButton";
import styles from "./FiboStepsButton.module.scss";

const FiboStepsButton = () => {
	const { t } = useTranslation("fibo", { keyPrefix: "lab" });
	const { textToImageStore } = useAppStore();

	return (
		<FiboPopoverButton
			icon={<StepsIcon />}
			buttonText={String(textToImageStore.config?.steps_num ?? t("settings.steps.placeholder"))}
			tooltip={t("settings.steps.tooltip")}
		>
			<TextToImageStepsSlider className={styles.slider} valueLabelDisplay="off" />
		</FiboPopoverButton>
	);
};

export default observer(FiboStepsButton);
